import { CONTRACT_KIND_LABELS, type ContractKind } from "@/services/docuseal";

/** No upload yet: the card's Upload PDF prompt explains that, not the Can't send list. */
export const AWAITING_UPLOAD = "no_one_off_contract_template";

/**
 * Staff copy for a send blocker. The backend's `no_<kind>_template` codes get a
 * message; every other reason is already prose.
 */
export function blockedReasonMessage(reason: string): string {
  // A per-deal upload, not an admin template: Documents cannot fix it.
  if (reason === AWAITING_UPLOAD) return "No custom contract has been uploaded yet.";
  // The Document view is any template with nothing to sign, not a type an admin picks.
  if (reason === "no_document_template") {
    return "No document-only template (nothing for the merchant to fill or sign) is turned on. An admin can add or enable one under Documents.";
  }
  const kind = /^no_(.+)_template$/.exec(reason)?.[1];
  if (!kind) return reason;
  const label = CONTRACT_KIND_LABELS[kind as ContractKind];
  return `No ${label ? `${label} ` : ""}template is turned on. An admin can add or enable one under Documents.`;
}
